import React from 'react';
import { Radio, MessageCircle, Share2, Briefcase } from 'lucide-react';

const TAB_META = {
  radio: { label: 'Radio Diary', Icon: Radio, color: 'text-orange-600' },
  whatsapp: { label: 'WhatsApp', Icon: MessageCircle, color: 'text-green-600' },
  social: { label: 'Social Burst', Icon: Share2, color: 'text-blue-600' },
  brief: { label: 'Evidence Brief', Icon: Briefcase, color: 'text-gray-700' },
};

export const FormatTabs = ({ active, onChange, available }) => {
  return (
    <div className="flex flex-wrap gap-2 border-b border-gray-200 mb-4">
      {available.map((key) => {
        const meta = TAB_META[key] || { label: key, Icon: Radio, color: 'text-gray-600' };
        const Icon = meta.Icon;
        const isActive = active === key;
        return (
          <button
            key={key}
            type="button"
            data-testid={`format-tab-${key}`}
            onClick={() => onChange(key)}
            className={`flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 transition ${
              isActive
                ? 'border-[#07743F] text-[#07743F]'
                : 'border-transparent text-gray-500 hover:text-gray-800'
            }`}
          >
            <Icon className={`w-4 h-4 ${isActive ? 'text-[#07743F]' : meta.color}`} />
            {meta.label}
          </button>
        );
      })}
    </div>
  );
};

export default FormatTabs;
